import { CopilotAdminPinningStatus } from '@office-start/copilot-types';
export function isAdminDisabledBizChat(featureGates, userEntitlements) {
    var _a;
    if (((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.immersiveBizchatM365AppGates) === null || _a === void 0 ? void 0 : _a.immersiveBizchatM365AppAdminSettingsOverrideEnabled) &&
        (userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.userCopilotAdminSetting) ===
            CopilotAdminPinningStatus.Unpinned) {
        return true;
    }
    return false;
}
//# sourceMappingURL=utilities.js.map